import React, { useContext } from "react"
import { ColorPickerStateContext } from "react-aria-components/ColorPicker"
import { cn } from "../utils"
import { TRANSPARENT, toValue } from "./use-color-value"

// The field's swatch when transparent: faint 8px squares over the field, with
// an edge so it doesn't vanish
const transparentSwatchPattern: React.CSSProperties = {
  backgroundImage:
    "conic-gradient(transparent 25%, rgba(0, 0, 0, 0.08) 0 50%, transparent 0 75%, rgba(0, 0, 0, 0.08) 0)",
  backgroundSize: "16px 16px",
  boxShadow: "inset 0 0 0 1px rgba(0, 0, 0, 0.1)"
}

/**
 * The current color, or a checkerboard when it's transparent. Decorative: the
 * hex box beside it carries the value for screen readers.
 */
export function ColorInputSwatch({ className }: { className?: string }) {
  const state = useContext(ColorPickerStateContext)
  const value = state ? toValue(state.color) : TRANSPARENT

  return (
    <span
      data-slot="color-input-swatch"
      className={cn(
        "block size-6 shrink-0 rounded",
        // White disappears against the field without an edge
        value === "#FFFFFF" && "border border-gray-200",
        className
      )}
      style={
        value === TRANSPARENT
          ? transparentSwatchPattern
          : { backgroundColor: value }
      }
    />
  )
}
